import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  inputsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    columnGap: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  icon: {
    fontSize: 42,
    marginTop: 24,
    marginBottom: 16
  }
}))
export default useStyles
